<style scoped lang="sass">
.mu-input
  width: 100%
  font-size: 20PX
  margin-bottom: 0
  padding-top: 0
  padding-bottom: 0
  min-height: 0

::v-deep
  .mu-text-field
    padding: 0 16PX
    border: 1PX solid rgba(51, 68, 85, 0.1)
    border-radius: 4PX
    background: #FFFFFF

  .mu-input-label
    top: 0 !important
    left: 16PX
    line-height: 0

  .float
    transform: translate3d(0, 26PX, 0) scale(1) !important

  // Hide default bottom border
  // 隐藏默认的下边框
  .mu-input-line,
  .mu-input-focus-line
    display: none

  // Input box text color
  // 输入框内文字的颜色
  .mu-text-field-input
    height: 50PX
    color: #334455
    caret-color: #10CFC9

// .input__focus Get focus status
// .input__focus 获取焦点时的状态
// .no-empty-state Value status in the input box
// .no-empty-state 输入框内有值时的状态
.mu-input__focus,
.no-empty-state
  color: #334455

  ::v-deep
    .mu-input-label
      margin-top: -2PX
      padding: 4PX
      background: #fff
      opacity: .9

.mu-input__focus
  ::v-deep
    .mu-text-field
      border: 1PX solid #10CFC9
</style>

<template lang="pug">
  mu-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    label-float
  )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({

})

class LandingInput extends Vue {

}

export default LandingInput
</script>
